import { render, staticRenderFns } from "./ModalImagem.vue?vue&type=template&id=51ba09a6&scoped=true"
import script from "./ModalImagem.vue?vue&type=script&lang=js"
export * from "./ModalImagem.vue?vue&type=script&lang=js"
import style0 from "./ModalImagem.vue?vue&type=style&index=0&id=51ba09a6&prod&lang=scss"
import style1 from "./ModalImagem.vue?vue&type=style&index=1&id=51ba09a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba09a6",
  null
  
)

export default component.exports